export const CHANGE_INPUT = 'containers/ForgotPassword/CHANGE_INPUT';
export const SUBMIT_FORM = 'containers/ForgotPassword/SUBMIT_FORM';
export const FORM_SUBMITTED_SUCCESS = 'containers/ForgotPassword/FORM_SUBMITTED_SUCCESS';
export const FORM_SUBMITTED_FAIL = 'containers/ForgotPassword/FORM_SUBMITTED_FAIL';
export const ERROR = 'containers/ForgotPassword/ERROR';
export const RESET = 'containers/ForgotPassword/RESET';
